module.exports = __webpack_public_path__ + "img/10_Foreground_and_horses-01.df90c20f.png";